import React from 'react';
import { Dialog, IconButton, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Close } from '@carbon/icons-react';
import { ModalType } from './QuotationCommonWrapper';

import { useHistory } from 'react-router-dom';

import useDocuments from '@hooks/useDocuments';

interface Props {
  open: boolean;
  rfqId?: string;
  partnerId?: string;
  quotationId?: string;
  handleModal: (type: ModalType) => void;
  onClose: () => void;
}
const QuotationConfirmModal = ({
  open,
  rfqId,
  partnerId,
  quotationId,
  handleModal,
  onClose
}: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const { onUpdateDocumentsCurrentId } = useDocuments();

  const onClick = async () => {
    if (!rfqId || !partnerId) return;

    onUpdateDocumentsCurrentId({ selectedQuotationId: quotationId });

    onClose();

    return history.push(
      history.location.pathname + '?menu=create_purchaseorder&p=2'
    );
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
    >
      <div className={classes.header}>
        <CustomizedTypography
          variant="h4"
          color="textPrimary"
          fontWeight="bold"
        >
          <i className="request-gtm-purchaseOrder-btn">발주하기</i>
        </CustomizedTypography>
        <IconButton className="close" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <div className={classes.content}>
        <CustomizedTypography
          variant="h4"
          color="textPrimary"
          gutterBottoms={4}
        >
          해당 견적조건으로 발주하시겠습니까?
        </CustomizedTypography>
      </div>
      <div className={classes.footer}>
        <CustomizedButton
          onClick={() => handleModal(null)}
          fullWidth
          variant="contained"
          color="default"
          size="large"
        >
          취소
        </CustomizedButton>
        <CustomizedButton
          onClick={onClick}
          fullWidth
          variant="contained"
          color="primary"
          size="large"
        >
          <i className="request-gtm-purchaseOrder-btn">이 조건으로 발주</i>
        </CustomizedButton>
      </div>
    </Dialog>
  );
};

export default QuotationConfirmModal;

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 476,
    padding: 0,
    borderRadius: 16,
    '& h4': {
      wordBreak: 'break-all'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '28px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '28px 20px'
    },
    '& .close': {
      padding: 0,
      '& svg': {
        width: 24,
        height: 24
      }
    }
  },
  content: {
    padding: '0px 24px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px 24px'
    }
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    '& button': {
      width: 'calc(100% / 2 - 4px)'
    },
    [theme.breakpoints.down('md')]: {
      padding: '16px'
    }
  }
}));
